import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

interface AuthState {
    user: null | {
        created_at: string;
        email: string;
        email_verified_at: string;
        id: number;
        image: null | string;
        name: string;
        phone: string;
        role: string;
        status: number;
        token: string;
        updated_at: string;
    };
    token: null | string;
}

const initialState: AuthState = {
    user: null,
    token: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ user: any; token: string | null }>) => {
            state.user = action.payload.user;
            state.token = action.payload.token;

            if (action.payload.token) {
                Cookies.set('accessToken', action.payload.token);
            } else {
                Cookies.remove('accessToken');
            }
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            Cookies.remove('accessToken');
        },
    },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
